export const IS_DARK_MODE_BANNER_CLOSED_LOCAL_STORAGE_KEY = 'dark_mode_banner_closed'

export enum ColorTheme {
  Dark = 'dark',
  Light = 'light',
}
